import PropTypes from "prop-types"
import { Link as LinkRouter } from "gatsby"
import React, { useState } from 'react';
import './header.styles.scss';
import hookLogo from '../../assets/images/hook-icon.png';
import { DemoButton } from './demo-button';
import { Dropdown } from './dropdown.js';
import { DropdownLogin } from './dropdown-login';
import { FaCaretDown, FaTimes, FaBars } from 'react-icons/fa';

const Header = () => {

    const [click, setClick] = useState(false);

    const [dropdown, setDropdown] = useState(false);

    const [dropdownLogin, setDropdownLogin] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const onMouseEnter = () => {
        if (window.innerWidth < 960) {
            setDropdown(false);
        } else {
            setDropdown(true);
        }
    };

    const onMouseLeave = () => {
        if (window.innerWidth < 960) {
            setDropdown(false);
        } else {
            setDropdown(false);
        }
    };

    const onMouseEnter2 = () => {
        if (window.innerWidth < 960) {
            setDropdownLogin(false);
        } else {
            setDropdownLogin(true);
        }
    };

    const onMouseLeave2 = () => {
        if (window.innerWidth < 960) {
            setDropdownLogin(false);
        } else {
            setDropdownLogin(false);
        }
    };

    // const closeMenuAndScrollToTop = () => {
    //     setClick(false);
    //     scroll.scrollToTop();
    // }

    return (
        <>
            <nav className='navbar'>
                <a href='https://hooklab.com.br/' className='navbar-logo'>
                    <img src={hookLogo} className='hook-logo' />
                    hook<span className='blue'>lab</span>
                </a>
                <div className='menu-icon' onClick={handleClick}>
                    {click ? <FaTimes /> : <FaBars />}
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <a href='https://hooklab.com.br/' className='nav-links'>
                            Sobre
                        </a>
                    </li>
                    <li className='nav-item display-none-mobile' onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                        <a className='nav-links' onClick={closeMobileMenu}>
                            Soluções <FaCaretDown />
                        </a>

                        {dropdown && <Dropdown />}
                    </li>
                    <li className='nav-item display-only-mobile'>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-de-concorrentes' className='nav-links' onClick={closeMobileMenu}>
                            Monitoramento de Concorrentes
                        </a>
                    </li>
                    <li className='nav-item display-only-mobile'>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-de-revendedores' className='nav-links' onClick={closeMobileMenu}>
                            Monitoramento de Revendedores
                        </a>
                    </li>
                    <li className='nav-item display-only-mobile'>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-netshoes' className='nav-links' onClick={closeMobileMenu}>
                            Monitoramento Netshoes
                        </a>
                    </li>
                    <li className='nav-item display-only-mobile'>
                        <a href='https://hooklab.com.br/solucoes/precificacao-dinamica' className='nav-links' onClick={closeMobileMenu}>
                            Precificação Dinâmica
                        </a>
                    </li>
                    <li className='nav-item display-only-mobile'>
                        <a href='https://hooklab.com.br/solucoes/solucoes-personalizadas' className='nav-links' onClick={closeMobileMenu}>
                            Soluções Personalizadas
                        </a>
                    </li>
                    <li className='nav-item'>
                        <a href='https://hooklab.com.br/planos' className='nav-links' onClick={closeMobileMenu}>
                            Planos
                        </a>
                    </li>
                    <li className='nav-item'>
                        <LinkRouter to='/' className='nav-links' onClick={closeMobileMenu}>
                            Blog
                        </LinkRouter>
                    </li>
                    <li className='nav-item display-none-mobile nav-right' onMouseEnter={onMouseEnter2} onMouseLeave={onMouseLeave2}>
                        <a className='nav-links' onClick={closeMobileMenu}>
                            Entrar
                        </a>

                        {dropdownLogin && <DropdownLogin />}
                    </li>
                    <div onClick={closeMobileMenu}>
                        <DemoButton />
                    </div>
                </ul>
            </nav>
        </>
    )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header